import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ModalBody } from 'reactstrap'
import React from 'react'
import { ServerErrorViewer } from '@/components/validation/serverErrorViewer'
import { CloseFooter } from '@/dialogs/common/closeFooter'

function ValidationErrorsDialog (props) {
  const { errorInfo } = props
  return <React.Fragment>
    <BasicHeader title='Common.Error' {...props} />
    <ModalBody>
      <ServerErrorViewer error={errorInfo} showErrorMessage />
    </ModalBody>
    <CloseFooter {...props} />
  </React.Fragment>
}

export default {
  component: ValidationErrorsDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/validationErrors.js